<template>
  <div>
    <SearchableTable
      :panel-header="'Sozialarbeiter'"
      :panel-route="'AddSocialWorker'"
      :show-search-bar="true"
      :table-data="socialWorkers"
      :table-meta-data="tableMetaData"
      :query-string="'setsocialWorkerSearchQuery'"
      :initial-search-query="socialWorkerSearchQuery"
      :row-click="triggerView"
      :default-sort="['attributes.last_name', 'asc']"
    />
  </div>
</template>

<script>
import SearchableTable from "../helperComponents/SearchableTable.vue";
import { mapGetters } from "vuex";

export default {
	name: "SocialWorkers",
	components: { SearchableTable },
	data() {
		return {
			tableMetaData: [
				{ "id": 0, "type": "name", "label": "Name", "sortField": "attributes.last_name" },
				{ "id": 1, "type": "string", "label": "Email", "field": "email", "sortField": "attributes.email" }
			]
		}
	},
	computed: {
		...mapGetters({
			socialWorkers: "getSocialWorkerFiltered",
			socialWorkerSearchQuery: "getSocialWorkerSearchQuery"
		})
	},
	methods: {
		triggerView(socialWorker) {
			this.$router.push({ name: "ViewSocialWorker",
				params: { id: socialWorker.id, data: socialWorker } });
		}
	}
}
</script>

<style scoped></style>
